module.exports = __webpack_public_path__ + "img/floorplan_gulfstreamG500_night.dd2aa7ca.png";